<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M2.34375 12.5C2.34375 6.89086 6.89086 2.34375 12.5 2.34375C18.1091 2.34375 22.6562 6.89086 22.6562 12.5C22.6562 18.1091 18.1091 22.6562 12.5 22.6562C6.89086 22.6562 2.34375 18.1091 2.34375 12.5ZM11.4128 10.9984C12.6067 10.4014 13.9511 11.4798 13.6274 12.7749L12.8888 15.7291L12.932 15.7075C13.318 15.5145 13.7872 15.671 13.9802 16.0569C14.1732 16.4428 14.0167 16.9121 13.6308 17.105L13.5876 17.1266C12.3936 17.7236 11.0492 16.6452 11.373 15.3501L12.1115 12.3959L12.0683 12.4175C11.6824 12.6105 11.2131 12.4541 11.0202 12.0682C10.8272 11.6822 10.9836 11.213 11.3695 11.02L11.4128 10.9984ZM12.5 9.375C12.9315 9.375 13.2812 9.02522 13.2812 8.59375C13.2812 8.16228 12.9315 7.8125 12.5 7.8125C12.0685 7.8125 11.7188 8.16228 11.7188 8.59375C11.7188 9.02522 12.0685 9.375 12.5 9.375Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgInfo',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>